export default __webpack_public_path__ + "static/media/turn-slight-right.6a5bd71d.svg";